class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
    this.input.addEventListener('change', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }
  
  getSearchResults(searchTerm) {
    let data_url = '';
    if (window.theme.template == 'page.compareProduct') {
      data_url = `/search/suggest?q=${searchTerm}&section_id=predictive-search&resources[type]=product`
    } else {
      data_url = `/search/suggest?q=${searchTerm}&section_id=predictive-search`
    }
    fetch(data_url)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }
        //console.log(response.text());
        return response.text();
      })
      .then((text) => {
        console.log(window.theme.template)

        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.open();
        
        let test = $('#Searchautocomplete-list').html();
        $('.js_auto_complete').html(test);
        if ($('.append-text').length == 0) {
          $('.search-tag').addClass("title-hidden");
        } else {
          $('.search-tag').removeClass("title-hidden");
        }
        if ($('.collection-list').length == 0) {
          $('.collection-data').addClass("title-hidden");
        } else {
          $('.collection-data').removeClass("title-hidden");
        }

        if ($('.append-text').length > 10) {
          $('#predictive-search-results-list').addClass("tag-search-scroll");
        } else {
          $('#predictive-search-results-list').removeClass("tag-search-scroll");
        }

        if ($('.collection-list').length > 5) {
          $('#predictive-search-results-list').addClass("collection-search-scroll");
        } else {
          $('#predictive-search-results-list').removeClass("collection-search-scroll");

        }
        if (window.theme.template == 'page.compareProduct') {
          $('.search_compare').addClass('search_data');
        } else {
          $('.search_compare').removeClass('search_data');
        }
        
        $('.search_data').click(function (e) {
          e.preventDefault();
          const handle = $(this).data('handle');
          console.log(handle);
          const url = new URL(location);
          const product1 = url.searchParams.get('product1');
          const product2 = url.searchParams.get('product2');
          const product3 = url.searchParams.get('product3');
          if(product1 && product2 && product3) {
            alert('Already 3 product added in compare please remove 1');
          }else{
            if (!product1) {
            url.searchParams.append('product1', handle);
            history.pushState({}, "", url);
            location.href = url + '&preview_theme_id=180271776009';
            return;
          }
          if (!product2 && product1 !== handle) {
            url.searchParams.append('product2', handle);
            history.pushState({}, "", url);
            location.href = url + '&preview_theme_id=180271776009';
            return;
          }
          if (!product3 && product2 !== handle && product1 !== handle) {
            url.searchParams.append('product3', handle);
            location.href = url + '&preview_theme_id=180271776009';
          }
          else {
            alert("Already product added");
          }
          }
          
          history.pushState({}, "", url);
          
        })
      })
      
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);

$(window).on("load resize", function (e) {
  if ($('#predictive-search-results>.predictive-product-wrapper .product-item__info .product-item__title').length > 0) {
    $('#predictive-search-results>.predictive-product-wrapper .product-item__info .product-item__title').matchHeight({
      byRow: true,
    });
  }
});